import { useState, useEffect } from "react";

function Webring1() {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);

    const webring1 = `<script type="text/javascript" src="https://fabstarotcorner.neocities.org/webring/onionring-widget.js" async></script>`;

    useEffect(() => {
        const scriptTag = document.createElement('script');
         scriptTag.src = 'https://fabstarotcorner.neocities.org/webring/onionring-widget.js';
         scriptTag.type = "text/javascript";
         scriptTag.async = true;

        // scriptTag.onload = () => {
        //     console.log("External script has successfully loaded.");
        //     setIsScriptLoaded(true); // Triggers re-render to execute dependent code
        //     };
        
        // scriptTag.onerror = () => {
        //     console.error("The script failed to load.");
        // };

         document.body.appendChild(scriptTag);
        //  console.log("webring init")
    }, []);

  return (
     <div id='gfdkris'></div>
  );
}

export default Webring1;